var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 8.64697C10.21 8.64697 12 6.85697 12 4.64697C12 2.43697 10.21 0.646973 8 0.646973C5.79 0.646973 4 2.43697 4 4.64697C4 6.85697 5.79 8.64697 8 8.64697ZM8 2.64697C9.1 2.64697 10 3.54697 10 4.64697C10 5.74697 9.1 6.64697 8 6.64697C6.9 6.64697 6 5.74697 6 4.64697C6 3.54697 6.9 2.64697 8 2.64697ZM14.39 11.207C12.71 10.347 10.53 9.64697 8 9.64697C5.47 9.64697 3.29 10.347 1.61 11.207C1.12206 11.4583 0.713305 11.8399 0.429104 12.3095C0.144902 12.779 -0.00362639 13.3181 3.95512e-06 13.867V20.647H2V13.867C2 13.487 2.2 13.147 2.5 12.987C3.71 12.377 5.63 11.647 8 11.647C8.76 11.647 9.47 11.717 10.13 11.847L8.58 15.147H5.75C4.23 15.147 3 16.377 3 17.897C3 19.417 4.23 20.647 5.75 20.647H14C15.1 20.647 16 19.747 16 18.647V13.867C16 12.747 15.39 11.717 14.39 11.207ZM6.94 18.647H5.75C5.34 18.647 5 18.307 5 17.897C5 17.487 5.34 17.147 5.75 17.147H7.64L6.94 18.647ZM14 18.647H9.15L12.09 12.377C12.63 12.577 13.1 12.787 13.5 12.987C13.8 13.147 14 13.487 14 13.867V18.647Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector3);
export default __webpack_public_path__ + "static/media/Vector (3).33aef10c10818c123c3bb02075c883a2.svg";
export { ForwardRef as ReactComponent };